import { useState, useRef } from 'react';
import { useForm } from '@formspree/react';
import { useScrollAnimation } from '../../../ganchos/usarAnimacionScroll';
import styles from './Contacto.module.css';

const WHATSAPP_NUM = '50230978165';
const WHATSAPP_MSG = encodeURIComponent('Hola SEIMA, me interesa solicitar una cotización.');
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUM}?text=${WHATSAPP_MSG}`;
const PHONE = '+502 3097 8165';
const EMAIL = 'info@seima.com.gt';

const REDES = [
  {
    nombre: 'Facebook',
    url: 'https://www.facebook.com/seimasuministrosgt/',
    icono: (
      <svg fill="currentColor" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
        <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c4.56-.93 8-4.96 8-9.75z" />
      </svg>
    ),
  },
  {
    nombre: 'Instagram',
    url: 'https://www.instagram.com/seima_suministrosgt/',
    icono: (
      <svg fill="currentColor" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.051.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
      </svg>
    ),
  },
  {
    nombre: 'LinkedIn',
    url: 'https://www.linkedin.com',
    icono: (
      <svg fill="currentColor" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.779-1.75-1.75s.784-1.75 1.75-1.75 1.75.779 1.75 1.75-.784 1.75-1.75 1.75zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
      </svg>
    ),
  },
  {
    nombre: 'TikTok',
    url: 'https://www.tiktok.com',
    icono: (
      <svg fill="currentColor" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
        <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.34 6.34 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V9.05a8.27 8.27 0 004.84 1.55V7.16a4.85 4.85 0 01-1.07-.47z" />
      </svg>
    ),
  },
];

const FORM_INICIAL = {
  nombre: '',
  correo: '',
  telefono: '',
  asunto: '',
  empresa: '',
  mensaje: '',
};

export const ContactSection = ({ prefillMessage = '' }) => {
  const [ref, visible] = useScrollAnimation({ threshold: 0.05 });
  const [form, setForm] = useState({ ...FORM_INICIAL, mensaje: prefillMessage });
  const [state, handleSubmit] = useForm('mdaqgzdr');
  const textareaRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    if (name === 'mensaje' && textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  };

  // Eliminamos handleSubmit local ya que usamos el de Formspree

  return (
    <section id="contact" ref={ref} className={`${styles.seccion} ${visible ? styles.visible : ''}`}>
      <div className="container">

        {/* ── Header ── */}
        <div className={styles.encabezado}>
          <h2 className={styles.titulo}>Contáctanos</h2>
          <div className={`${styles.lineaTitulo} ${visible ? styles.lineaVisible : ''}`} />
          <p className={styles.sub}>
            Solicita cotización, resolución técnica o cuéntanos tu necesidad. Respondemos en menos de 24 h.
          </p>
        </div>

        {/* ── Main Grid ── */}
        <div className={styles.grid}>

          {/* ── Form column ── */}
          <div className={`${styles.columnaForm} ${visible ? styles.columnaVisible : ''}`}>
            {state.succeeded ? (
              <div className={styles.exitoBloque}>
                <div className={styles.exitoIcono}>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" width="36" height="36">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className={styles.exitoTitulo}>Mensaje enviado</h3>
                <p className={styles.exitoDesc}>
                  Nos pondremos en contacto contigo a la brevedad posible. Gracias por confiar en SEIMA.
                </p>
                <button
                  className={styles.btnReset}
                  onClick={() => window.location.reload()}
                >
                  Enviar otro mensaje
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className={styles.form}>

                {/* Nombre */}
                <div className={styles.campo}>
                  <label className={styles.label} htmlFor="cf-nombre">Nombre completo *</label>
                  <input
                    id="cf-nombre"
                    type="text"
                    name="nombre"
                    value={form.nombre}
                    onChange={handleChange}
                    required
                    className={styles.input}
                    placeholder="Tu nombre completo"
                    autoComplete="name"
                  />
                </div>

                {/* Correo + Teléfono */}
                <div className={styles.fila}>
                  <div className={styles.campo}>
                    <label className={styles.label} htmlFor="cf-correo">Correo electrónico *</label>
                    <input
                      id="cf-correo"
                      type="email"
                      name="correo"
                      value={form.correo}
                      onChange={handleChange}
                      required
                      className={styles.input}
                      placeholder="tu@correo.com"
                      autoComplete="email"
                    />
                  </div>
                  <div className={styles.campo}>
                    <label className={styles.label} htmlFor="cf-telefono">Teléfono *</label>
                    <input
                      id="cf-telefono"
                      type="tel"
                      name="telefono"
                      value={form.telefono}
                      onChange={handleChange}
                      required
                      className={styles.input}
                      placeholder="+502 0000 0000"
                      autoComplete="tel"
                    />
                  </div>
                </div>

                {/* Asunto + Empresa */}
                <div className={styles.fila}>
                  <div className={styles.campo}>
                    <label className={styles.label} htmlFor="cf-asunto">Asunto *</label>
                    <input
                      id="cf-asunto"
                      type="text"
                      name="asunto"
                      value={form.asunto}
                      onChange={handleChange}
                      required
                      className={styles.input}
                      placeholder="¿En qué podemos ayudarte?"
                    />
                  </div>
                  <div className={styles.campo}>
                    <label className={styles.label} htmlFor="cf-empresa">Empresa *</label>
                    <input
                      id="cf-empresa"
                      type="text"
                      name="empresa"
                      value={form.empresa}
                      onChange={handleChange}
                      required
                      className={styles.input}
                      placeholder="Nombre de tu empresa"
                      autoComplete="organization"
                    />
                  </div>
                </div>

                {/* Mensaje */}
                <div className={styles.campo}>
                  <label className={styles.label} htmlFor="cf-mensaje">Mensaje *</label>
                  <textarea
                    id="cf-mensaje"
                    ref={textareaRef}
                    name="mensaje"
                    value={form.mensaje}
                    onChange={handleChange}
                    required
                    className={styles.textarea}
                    placeholder="Describe tu proyecto, necesidad o consulta técnica..."
                    rows={4}
                  />
                </div>

                <button type="submit" className={styles.btnEnviar} disabled={state.submitting}>
                  {state.submitting ? (
                    <>
                      <svg className={styles.spinner} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} width="22" height="22" aria-hidden="true">
                        <circle cx="12" cy="12" r="10" strokeOpacity="0.2" />
                        <path d="M12 2a10 10 0 0110 10" strokeLinecap="round" />
                      </svg>
                      Enviando...
                    </>
                  ) : (
                    <>
                      Enviar mensaje
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" width="17" height="17" aria-hidden="true">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
                      </svg>
                    </>
                  )}
                </button>

              </form>
            )}
          </div>

          {/* ── CTA Sidebar ── */}
          <div className={`${styles.columnaCTA} ${visible ? styles.ctaVisible : ''}`}>

            {/* WhatsApp */}
            <a href={prefillMessage ? `https://wa.me/${WHATSAPP_NUM}?text=${encodeURIComponent(prefillMessage)}` : WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className={styles.btnWhatsapp}>
              <span className={styles.whatsappIcono}>
                <svg fill="currentColor" viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
              </span>
              <div className={styles.whatsappTexto}>
                <span className={styles.whatsappTitulo}>¡Mándanos un mensaje!</span>
                <span className={styles.whatsappSub}>Respuesta rápida garantizada</span>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" width="15" height="15" className={styles.whatsappArrow} aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
              </svg>
            </a>

            {/* Contact items */}
            <div className={styles.ctaItems}>
              <div className={styles.ctaFila}>
                <a href={`tel:${PHONE.replace(/\s/g, '')}`} className={styles.ctaItem}>
                  <span className={styles.ctaIcono}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" width="24" height="24" aria-hidden="true">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-2.824-1.806-5.194-4.177-7-7l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                    </svg>
                  </span>
                  <div>
                    <span className={styles.ctaEtiqueta}>Llámanos</span>
                    <span className={styles.ctaValor}>{PHONE}</span>
                  </div>
                </a>

                <a href="tel:+50223199494" className={styles.ctaItem}>
                  <span className={styles.ctaIcono}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" width="24" height="24" aria-hidden="true">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-2.824-1.806-5.194-4.177-7-7l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                    </svg>
                  </span>
                  <div>
                    <span className={styles.ctaEtiqueta}>Llámanos</span>
                    <span className={styles.ctaValor}>+502 2319 9494</span>
                  </div>
                </a>
              </div>

              <a href={`mailto:${EMAIL}`} className={styles.ctaItem}>
                <span className={styles.ctaIcono}>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" width="24" height="24" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                  </svg>
                </span>
                <div>
                  <span className={styles.ctaEtiqueta}>Escríbenos</span>
                  <span className={styles.ctaValor}>{EMAIL}</span>
                </div>
              </a>
            </div>

            {/* Social */}
            <div className={styles.redes}>
              <span className={styles.redesTitulo}>Síguenos en Redes</span>
              <div className={styles.redesIconos}>
                {REDES.map((red) => (
                  <a
                    key={red.nombre}
                    href={red.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.redIcono}
                    aria-label={red.nombre}
                    title={red.nombre}
                  >
                    {red.icono}
                  </a>
                ))}
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};
export default ContactSection;
